const filter = {
	$this: $( '.js-filter' ),
	$listing: $( '.js-items' ),
	$archive: $( '.js-items-archived' ),
	$archiveLabel: $( '.js-label-archived' ),
	$result: $( '.js-results > span'),
	$counter: $( '.js-open-filter > span'),
	$reset: $( '.js-reset-filter' ),
	$loader: $( '.js-filter-loader' ),
	$extraFilter: $( '.js-extra-filter' ),
	$filterSpacer: $( '.js-filter-spacer' ),
	$preFilter: $( '.js-pre-filter' ),
	used: false,
	noBigItems: true,
};

const numberOfGroups = filter.$this.find( '.js-filter-group' ).length + filter.$extraFilter.length;

let chosenFilters = {},
	loader = true,
	count_overtake = 0;

function openFilter() {
	if ( ! filter.$this.hasClass( 'is-open' ) ) {

		filter.used = true;

		// fadeOut elements:
		$( '.js-main' ).addClass( 'filter-is-open' );
		filter.$extraFilter.addClass( 'is-hidden' );
		$( '.js-items' ).addClass( 'is-hidden' );
		$( '.js-filter-results' ).addClass(' is-hidden' );

		setTimeout( function() {

			let filterHeight = filter.$this.outerHeight( true );

			// move doelgroep-bg down:
			// if DeKubus:
			if ( filter.$this.hasClass( 'filter--dekubus') ) {
				filter.$filterSpacer.css("height", filterHeight + 70 ).addClass("is-shown");
				filter.$filterSpacer.children( '.bg' ).css( 'bottom', 440 - filterHeight );
			} else {
				filter.$filterSpacer.css("height", filterHeight).addClass("is-shown");
			}

			setTimeout( function() {

				// show filter:
				filter.$this.addClass( 'is-open' ).fadeIn( 300, function() {
					$( '.js-filter' ).icons.init( '.svg-icon' );

					// reposition .content
					let top = 360 - filterHeight;
					if ( Modernizr.mq('(max-width: 767px)') ) {
						top = -150;
					}
					// if DeKubus:
					if ( filter.$this.hasClass( 'filter--dekubus') ) {
						top = 340 - filterHeight;
						if ( Modernizr.mq('(max-width: 767px)') ) {
							top = -300;
						}
					}
					$( '.js-content' ).css( { 'top': top + 'px' } );
					filter.$extraFilter.removeClass( 'is-hidden' );
					$( '.js-items' ).removeClass( 'is-hidden' );
					$( '.js-filter-results' ).removeClass( 'is-hidden' );

				} );

			}, 700 );

		}, 300 );

	}
};

function closeFilter() {
	if ( filter.$this.hasClass( 'is-open' ) ) {

		$( '.js-extra-filter' ).addClass( 'is-hidden' );
		$( '.js-items' ).addClass( 'is-hidden' );
		filter.$this.removeClass( 'is-open' ).fadeOut( 300 );

		setTimeout( function() {

			filter.$filterSpacer.removeAttr( 'style' ).removeClass( 'is-shown' ).children( '.bg' ).removeAttr( 'style' );

			$( '.js-content' ).removeAttr( 'style' );

			setTimeout( function() {

				$( '.js-main' ).removeClass( 'filter-is-open' );
				$( '.js-extra-filter' ).removeClass( 'is-hidden' );
				$( '.js-items' ).removeClass( 'is-hidden' );
				$( '.js-filter-results' ).removeClass( 'is-hidden' );

			}, 300 );

		}, 300 );

	}
};

function resetFilter() {
	chosenFilters = {};
	count_overtake = 0;
	$( '.js-filter-item' ).removeClass( 'is-active' );
	updateCourses();
	createURL();
};

function removeFromChosenFilters( choice, group, label ) {
	if (chosenFilters[group] == undefined ) {
		chosenFilters[group] = { label: label, items: [] };
	}
	//chosenFilters[group]['items'].pop( choice ); // removes only last item!
	const filterArray = chosenFilters[group]['items'];
	const index = filterArray.indexOf(choice);

	filterArray.splice(index, 1);

	return chosenFilters;
}

function addToChosenFilters( choice, group, label ) {
	if (chosenFilters[group] == undefined || Object.entries(chosenFilters[group]).length === 0 ) {
		chosenFilters[group] = { label: label, items: [] };
	}
	chosenFilters[group]['items'].push( choice );
	return chosenFilters;
}

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
    vars[key] = value.split( '+' );
  });
  return vars;
}

function createURL() {

	let urlFilters = '';

	//check which item belongs to chosen filter options
	if ( Object.entries(chosenFilters).length > 0 ) {
		for (var group in chosenFilters) {
			if (chosenFilters.hasOwnProperty(group)) {
				const label = chosenFilters[group].label;
				if ( '' == urlFilters ) {
					urlFilters += '?';
				}
				if ( chosenFilters[group].items.length > 0 ) {
					if ( urlFilters.length > 1 ) {
						urlFilters += '&';
					}
					urlFilters += label + '=';
					chosenFilters[group].items.forEach( function (item, i) {
						if ( i == 0 ) {
							urlFilters += item;
						} else {
							urlFilters += '+' + item;
						}
					} );
				}
			}
		}
	}

	var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
	window.history.replaceState( {} , document.title, url + urlFilters );
}

function activateItemsBasedOnUrl() {
	const urlParams = getUrlVars();
	if ( Object.entries(urlParams).length !== 0 || urlParams.constructor !== Object ) {
		for (var label in urlParams) {
			for (var item in urlParams[label]) {
				const $item = $( '.js-filter-group, .js-extra-filter' ).find( `.js-filter-item[data-filter-label='${label}'][data-filter='${urlParams[label][item]}']` );
				activateItem( $item );
				// no loader after first time activeItem:
				if ( loader ) {
					loader = false;
				}
			}
		}
	} else {
		updateCourses();
	}
}

function activateItem( $item ) {
	if ( $item.hasClass( 'is-active' ) ) {
		$item.removeClass( 'is-active' );
		chosenFilters = removeFromChosenFilters( $item.data('filter'), $item.data('filter-group'), $item.data('filter-label') );
		// Remove from counter overtake if not main filter
		if ( ! $item.hasClass( 'js-filter-item--extra' ) ) {
			count_overtake --;
		}
		updateCourses();
		createURL();
	} else {
		$item.addClass( 'is-active' );
		filter.used = true;
		// If radio: unactivate other items in .filter-block:
		if ( $item.find( '.radio' ).length > 0 ) {
			$item.parents( '.js-filter-block' ).children( '.js-filter-item' ).each( function( ) {
				var $child = $( this );
				$child.removeClass( 'is-active' );
				chosenFilters = removeFromChosenFilters( $child.data('filter'), $child.data('filter-group'), $child.data('filter-label') );
			} );
		}
		// If 'filter-item-extra': unactivate siblings:
		if ( $item.hasClass( 'js-filter-item--extra' ) ) {
			$item.siblings( '.js-filter-item' ).each( function( $sibling ) {
				var $sibling = $( this );
				$sibling.removeClass( 'is-active' );
				chosenFilters = removeFromChosenFilters( $sibling.data('filter'), $sibling.data('filter-group'), $sibling.data('filter-label') );
			} );
		}
		// If 'filter-item-big': activate item in filter:
		if ( $item.hasClass( 'js-filter-item-big' ) ) {
			const filterValue = $item.attr('data-filter');
			filter.$this.find( '.filter-item[data-filter="'+ filterValue +'"]' ).addClass( 'is-active' );
		}
		chosenFilters = addToChosenFilters( $item.data('filter'), $item.data('filter-group'), $item.data('filter-label') );
		// Add to counter overtake if not main filter
		if ( ! $item.hasClass( 'js-filter-item--extra' ) ) {
			count_overtake ++;
		}
		updateCourses();
		createURL();
	}
};

function createCourseItem( data ) {

	var image = data.image;
	if ( image === null) {
		image = data.placeholder;
	}

	var icon;
	if (data.hasOwnProperty('icon') && typeof data.icon !== 'undefined') {
		icon = data.icon;
	} else {
		icon = '';
	}

	const isCultuurPlus = document.querySelector('[data-archive="cultuurplus"]');

	let courseItem;

	if (isCultuurPlus) {
		courseItem = `
		<a href="${data.url}" class="cp-card-alt">
			<div class="load-image cp-card-alt__image">
				<img data-src="${image}" alt="${data.image_alt}" src="" data-align="middle center" data-loader="false">
			</div>
			<div class="cp-card-alt__content">
				${
					data.groups_term_names.group1.split(', ').map(label => (
						`<span class="cp-card-alt__label label">${label}</span>`
					))
				}
				<p class="cp-card-alt__title">${data.title}</p>
			</div>
		</a>
		`
	} else {
		courseItem = `<div class="course-item-outer"><a href="${data.url}" class="course-item">
		<div class="course-item-image">
			<div class="load-image">
				<img data-src="${image}" alt="${data.image_alt}" src="" data-align="middle center" data-loader="false"/>
			</div>
			${icon && (`<div class="filter-icon-container"><img src="${icon}" class="filter-icon"></div>`)}
		</div>
		<div class="course-item-content">
			<h2 class="small">${data.title}</h2>
			<span class="genre">${data.groups_term_names.group4}</span>
			<span class="type">${data.groups_term_names.group2}</span>
		</div>
	</a></div>`;
	}

	return courseItem;
}

function updateResults( count_results ) {
	filter.$result.text( count_results );
};

function updateSelected( count_overtake ) {
	if( count_overtake  == 0 ){
		filter.$counter.removeClass('counter' );
		filter.$counter.html( '<i class="svg-icon" data-icon="icon-filter" data-fill="#fff"></i>' );
	} else {
		filter.$counter.addClass('counter' );
		filter.$counter.text( count_overtake );
	}
};

function getShowGroups( data, group ) {
	var show_group = false;
	// forEach is synchronous!, return will work AFTER forEach is done.
	chosenFilters[ group ][ 'items' ].forEach( function( item ) {
		if (data.groups[ group ].includes( item )) {
			if (!show_group) {
				// TODO: kan includes handiger?
				show_group = data.groups[ group ].includes( item );
			}
		}
	} );
	return show_group;
}

function updateCourses() {

	// ====== if filter at least once used or opened ======
	if ( filter.used || filter.noBigItems ) {

		filter.$preFilter.addClass('is-hidden');
		filter.$listing.removeClass( 'is-visible' ).html('');

		if ( 'undefined' != typeof archivedCourses ) {
			filter.$archive.removeClass( 'is-visible' ).html('');
		}

		if ( loader ) {
			filter.$loader.fadeIn();
		}

		let count_results = 0;

		// are previously selected filters empty?
		if (Object.entries(chosenFilters).length > 0) {

				$.each(chosenFilters, function( group, data ){
					if(data['items'].length === 0 ){
						//console.log('is empty');
						delete chosenFilters[group];
					}
				});
		}

		// === if noFilters are selected ===
		let noFilters = Object.entries(chosenFilters).length === 0 && chosenFilters.constructor === Object ? true : false;

		let archive_results = 0;

		if ( noFilters ) {
			// if no filters, no checks need to be done, all items shown:
			$.each( $.parseJSON( resultCourses ), function( i, data ) {
				let courseItem = createCourseItem( data );
				filter.$listing.append( courseItem );
				count_results++;
			} );

			if ( 'undefined' != typeof archivedCourses ) {
				$.each( $.parseJSON( archivedCourses ), function( i, data ) {
					let courseItem = createCourseItem( data );
					filter.$archive.append( courseItem );
					count_results++;
					archive_results++;
				} );
			}

		} else { // === if filters are selected ===

			$.each( $.parseJSON( resultCourses ), function( i, data ) {

				let show_groups = [];

				for ( var j = 1; j <= numberOfGroups; j++ ) {
					let show_group = true;
					let group = 'group' + j;

					if (data.groups[group] && data.groups[group].length > 0 && chosenFilters[group] != undefined && chosenFilters[group]['items'].length > 0 ) {
						show_group = getShowGroups( data, group );
					}
					// don't show items with no entry for selected group
					if( !data.groups[group] && chosenFilters[group] != undefined ){
						show_group = false;
					}

					show_groups.push(show_group);
				}

				let itemShouldBeShown = show_groups.every( el => el === true );

				if ( itemShouldBeShown ) {
					let courseItem = createCourseItem( data );
					filter.$listing.append( courseItem );
					count_results++;
				}
			} );

			if ( 'undefined' != typeof archivedCourses ) {
				$.each( $.parseJSON( archivedCourses ), function( i, data ) {

					let show_groups = [];

					for ( var j = 1; j <= numberOfGroups; j++ ) {
						let show_group = true;
						let group = 'group' + j;

						if (data.groups[group] && data.groups[group].length > 0 && chosenFilters[group] != undefined && chosenFilters[group]['items'].length > 0 ) {
							show_group = getShowGroups( data, group );
						}
						// don't show items with no entry for selected group
						if( !data.groups[group] && chosenFilters[group] != undefined ){
							show_group = false;
						}

						show_groups.push(show_group);
					}

					let itemShouldBeShown = show_groups.every( el => el === true );

					if ( itemShouldBeShown ) {
						let courseItem = createCourseItem( data );
						filter.$archive.append( courseItem );
						count_results++;
						archive_results++;
					}
				} );
			}
		}

		updateResults( count_results );
		updateSelected (count_overtake );

		filter.$loader.fadeOut( 300, function() {

			// if no results:
			if (count_results == 0) {
				filter.$listing.html('<div class="center"><p class="msg-no-results">Er zijn geen resultaten gevonden.</p></div>').addClass( 'is-visible');
			}

			filter.$listing.addClass( 'is-visible' );

			if ( archive_results == 0 ) {
				filter.$archiveLabel.addClass('is-hidden').removeClass('is-visible');
				filter.$archive.addClass('is-hidden').removeClass('is-visible');
			} else {
				filter.$archiveLabel.removeClass('is-hidden').addClass('is-visible');
				filter.$archive.removeClass('is-hidden').addClass('is-visible');
			}

			setTimeout( function() {
				filter.$listing.icons.init( '.svg-icon' );
				filter.$listing.find( '.load-image' ).imageLoader();
				filter.$archive.icons.init( '.svg-icon' );
				filter.$archive.find( '.load-image' ).imageLoader();
			}, 500 );

		});

	}

};

filter.init = function() {

	activateItemsBasedOnUrl(); // updateCourses in this function

	filter.$reset.on( 'click', function( e ) {
		e.preventDefault();
		resetFilter();
	} );

	$( '.js-open-filter' ).on( 'click', function( e ) {
		e.preventDefault();
		e.stopPropagation();
		openFilter();
	} );

	$( '.js-close-filter' ).on( 'click', function( e ) {
		e.preventDefault();
		e.stopPropagation();
		closeFilter();
	} );

	$( '.js-filter-item:not(.is-inactive)' ).on( 'click', function( e ) {
		e.preventDefault();
		e.stopPropagation();
		activateItem( $(this ) );
	} );

	// Testing:
	//$( '.js-open-filter' ).click();

};

export { filter };
